module.exports = __webpack_public_path__ + "images/application/bg-servers-shadow-71da5b28.png";